// Generado desde design-system/lib/cn.ts — no editar; edita el .ts/.tsx y corre build-ds.
import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';
/*
 * tailwind-merge necesita conocer las escalas propias del preset; si no,
 * confunde `text-body` (tamaño) con un color y borra `text-primary-on`.
 * Mantener sincronizado con design-system/tokens/tailwind-preset.cjs.
 */
const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [
                { text: ['eyebrow', 'caption', 'body-sm', 'body', 'lead', 'title-sm', 'title', 'title-lg', 'display', 'display-xl', 'kpi', 'kpi-lg'] },
            ],
            shadow: [{ shadow: ['glass', 'relief', 'relief-sm', 'sunken', 'sunken-sm', 'primary'] }],
        },
    },
});
/** Combina clases condicionales y resuelve conflictos de Tailwind (la última gana). */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
